import { useMemo, useState } from 'react';

import useQuickFilters from '../../../hooks/useQuickFilters';
import useDateScope from '../../../hooks/useDateScope';
import toFilterInput from '../../../toFilterInput';
import useToFixedFilters from 'hooks/useToFixedFilters';
import isPerformanceBoard from '../../../isPerformanceBoard';

// There is a lot of noise here.
// We will refactor / tidy when taking on Boards v3 project
const useFilteringState = ({
  board,
  popupFilters,
  scopeFilters,
}: {
  board: PerformanceBoardTypes.Board | CustomerLaneBoard;
  popupFilters?: FilterPlateType[];
  scopeFilters?: FilterPlateType[];
}) => {
  const [dataTypes] = useState([board.dataType]);
  const toDrillDowns = useToFixedFilters();
  const dateRange = useDateScope({});

  const quickFilters = useQuickFilters(
    `${board.dataType} - board: ${board.id}`,
  );
  const [drillDowns, setDrillDowns] = useState<FilterPlateType[]>(
    () => popupFilters || window.emptyArray,
  );
  const [selectedQuickFilters, setSelectedQuickFilters] = useState<
    LegacySavedFilter[]
  >([]);

  const scope = useMemo((): FilterPlateType[] => {
    const newScope: FilterPlateType[] = [];
    if (scopeFilters) {
      newScope.push(...scopeFilters);
    }
    if (isPerformanceBoard(board)) {
      newScope.push(...board.plates);
    }
    return newScope;
  }, [board, scopeFilters]);

  const netQuickFilters = useMemo(() => {
    const filters: FilterInput[] = [];
    filters.push(
      ...selectedQuickFilters.map((qf) => toFilterInput(qf, [], toDrillDowns)),
    );
    return filters;
  }, [selectedQuickFilters, toDrillDowns]);

  return {
    dataTypes,
    dateRange,
    quickFilters,
    drillDowns,
    setDrillDowns,
    scope,
    selectedQuickFilters,
    setSelectedQuickFilters,
    netQuickFilters,
  };
};

export default useFilteringState;
